'use strict';/* global define, console */define('modules/time/services/duration-converter/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     factory.$inject = ["moment"];
function factory(moment){// jshint validthis:true
// jshint latedef:false
return{getDatesTillToday:getDatesTillToday};/**
     * Method to get feedback periods from past durations
     *
     * @param  {String} duration - duration for which to fetch periods
     * @return  {Obejct} dates - duration converted to an object with from/to dates
     *
     */function getDatesTillToday(durationKey){var duration=moment.duration(durationKey);return{from:moment().subtract(duration).utc().toDate(),to:moment().utc().toDate()};}/**
     * Method to get feedback periods from future durations
     *
     * @param  {String} duration - duration for which to fetch periods
     * @return  {Obejct} dates - duration converted to an object with from/to dates
     *
     */function getDatesFromToday(durationKey){var duration=moment.duration(durationKey);return{from:moment().utc().toDate(),to:moment().add(duration).utc().toDate()};}}module.exports=factory;});
